import React from 'react';

import classNames from 'classnames';

import { CheckboxProps } from './Checkbox.interface';

const getCheckboxClasses = (isDisabled?: boolean, className?: string): string =>
  classNames(
    'rds-checkbox',
    {
      'is-rds-disabled': isDisabled,
    },
    className,
  );

const getCheckmarkIconClasses = (colorBranded: boolean): string =>
  classNames('rds-checkmark', {
    'is-white-labeled-primary-color': colorBranded,
  });

const RdsCheckbox = React.forwardRef<
  HTMLInputElement, // The reference type - which element the final ref is attached to.
  CheckboxProps
>(
  (
    {
      children,
      className,
      colorBranded = true,
      isChecked,
      isDefaultChecked,
      isDisabled,
      id,
      isRequired,
      name,
      onChange,
      value,
      ...otherLabelAttributes
    },
    forwardedRef,
  ) => {
    return (
      <label
        {...otherLabelAttributes}
        className={getCheckboxClasses(isDisabled, className)}
        htmlFor={id}
      >
        <input
          checked={isChecked}
          defaultChecked={isDefaultChecked}
          disabled={isDisabled}
          id={id}
          name={name}
          onChange={onChange}
          ref={forwardedRef}
          required={isRequired}
          type="checkbox"
          value={value}
        />
        <span className={getCheckmarkIconClasses(colorBranded)}></span>
        <span className="rds-checkbox-text">{children}</span>
      </label>
    );
  },
);

export default RdsCheckbox;
